import { LampDesk } from "lucide-react";
import React from "react";

const PharmacistProductivityCard: React.FC = () => {
    const pharmacists = [
        { name: "Sarah M", score: 95 },
        { name: "John D", score: 82 },
        { name: "Vishal", score: 45 },
        { name: "Emily", score: 78 },
        { name: "Anandhu", score: 48 },
        { name: "Mike", score: 75 }
    ];

    return (
        <div className="flex flex-col items-start justify-start w-full border border-gray-200 rounded-xl">
            <div className="flex flex-row items-center justify-start gap-x-2 w-full py-2 px-4">
                <LampDesk className="text-gray-500 h-5 w-5"/>
                <span className="text-sm text-gray-500 font-normal">Pharmacist Productivity</span>
            </div>
            <div className="w-full border-[0.2px] border-gray-300" />
            <div className="w-full p-4 flex flex-col gap-y-4">
                <h3 className="text-base font-semibold text-gray-900">Weighted Score: RX Count vs Inventory</h3>
                <div className="flex flex-col gap-y-3">
                    {pharmacists.map((pharmacist, index) => (
                        <div key={index} className="flex flex-col gap-y-1">
                            <span className="text-sm font-medium text-gray-900">{pharmacist.name}</span>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                                <div 
                                    className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                    style={{ width: `${pharmacist.score}%` }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PharmacistProductivityCard;
